import React, { useState, useRef, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { ADAARIARoles } from '../../../../models/ADA';
import { getNavbarHeight, getViewportDimensions } from '../../../../models/Utils';

import './InfoColumns.scss';
import { LearnMoreButton } from '../LearnMore/LearnMoreButton';
import Arrow from '../../../Common/Arrow/Arrow';

const mobileScreenThreshold = 767; // MUST BE IN SYNC WITH CSS

const InfoColumns = React.forwardRef((props, theRef) => {
  const [ isMobileLayout, setIsMobileLayout ] = useState(false);
  const refIsMobileLayout = useRef(isMobileLayout);
  const [ rightHeight, setRightHeight ] = useState(null);
  const titleRef = useRef(null);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const container = useRef(null);
  const columns = props.data.Columns.map(column => ({
    title: column.Header,
    text: column.Body,
    learnMore: column.LearnMore,
    columnImage: column.ColumnImage
  }));

  const hideLearnMoreLinks = columns.some((column) => column.learnMore == null || !column.learnMore.HasLink);

  const getColumns = () => {
    let items = [];
    columns.forEach((column, i) => {
      items.push(
        <div className="cpvi-grid-col w4" key={i}>
          <div
            className="vbn-ic-column-wrapper"
            // tabIndex="-1"
            // role={ADAARIARoles.Group}
            // aria-label={`Box ${i+1}`}
          >
            <div className="vbn-ic-column-image-wrapper">
              <div role="img" aria-label={column.columnImage.AltText} className="vbn-ic-column-image" style={{ backgroundImage: `url("${column.columnImage.Image}")` }}/>
            </div>
            <div className={`vbn-ic-info-wrapper ${ hideLearnMoreLinks ? 'hide-learn-more-links' : '' }`}>
              <h3 className="vbn-ic-info--title" role={ADAARIARoles.Heading}>{column.title}</h3>
              <div className="vbn-ic-info--text">{column.text}</div>
              <LearnMoreButton
                data={column.learnMore}
                className='vbn-ic-info--learn-more'
              />
            </div>
          </div>
        </div>
      );
    });
    return items;
  };

  const handleScroll = () => {
    if (!refIsMobileLayout.current) return;

    // const viewport = getViewportDimensions();
    // columnRefs.forEach((column, i) => {
    //   const rect = column.current.getBoundingClientRect();
    //   const bodyText = columnBodyTextRefs[i].current;
    //   const innerTextHeight = bodyText.getElementsByClassName('bbf-2cs-column--text-inner')[0].getBoundingClientRect().height;
    //   bodyText.style.height = rect.y + rect.height + mobileSpaceBetween <= viewport.height ? `${innerTextHeight}px` : '0px';
    // });
  };

  const handleResize = () => {
    const marginTop = getNavbarHeight();
    const viewport = getViewportDimensions();
    const height = viewport.height - marginTop;
    const onMobile = viewport.width <= mobileScreenThreshold;
    setIsMobileLayout(onMobile);
    refIsMobileLayout.current = onMobile;
    if (!onMobile) {
      const rh = titleRef.current.getBoundingClientRect().height;
      setRightHeight(`${rh}px`);
      // columnRefs.forEach((columnRef, i) => {
      //   columnRef.current.style.height = '';
      //   columnBodyTextRefs[i].current.style.opacity = '';
      // });
    } else {
      setRightHeight('');
      // const maxH = getViewportDimensions().height * 0.4;
      // setMobileMaxHeight(maxH);
      // refMobileMaxHeight.current = maxH;
    }
  };

  useLayoutEffect(() => {
    handleResize();
    handleScroll();

    window.addEventListener('resize', handleResize);
    document.body.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.body.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      className="vbn-info-columns"
      role={ADAARIARoles.Group}
      aria-label={`Section: ${props.data.Title}`}
      tabIndex="-1"
    >
      <div className="vbn-ic-wrapper" ref={container}>
        <div className="cpvi-grid-container">
          <div className="cpvi-grid-row vbn-ic-title-and-link">
            <div className="vbn-ic-title-wrapper cpvi-grid-col w6" ref={titleRef}>
              <div className="vbn-ic-title" role={ADAARIARoles.Heading}>{props.data.Title}</div>
            </div>
            <div className="vbn-ic-more-stories-wrapper cpvi-grid-col w6" style={{ height: rightHeight }}>
              <div className="vbn-ic-more-stories-holder">
                <LearnMoreButton
                  className="vbn-ic-more-stories"
                  data={props.data.MoreStories}
                />
                <Arrow hideFromADA={true} direction="right" width={isMobileLayout ? "3px" : "4px"}/>
              </div>
            </div>
          </div>
        </div>
        <div className="cpvi-grid-container">
          <div className="cpvi-grid-row">
            {getColumns()}
          </div>
        </div>
      </div>
    </div>
  );
});

export default InfoColumns;
